<template>
    <div id="appLayout">
        <NavBar></NavBar>
        <div class="nj-views">
            <div class="nj-view-container">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>

import NavBar from "../components/NavBar.vue"

export default {
    components: {
        NavBar,
    },
}
</script>